import React from 'react';
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import withAuthorization from "../../../services/Authorization";
import SAInputLabel from "../../common/input/SAInputLabel";
import DateFormat from "../../common/format/DateFormat";
import moment from 'moment';
import WarningText from "../../common/text/WarningText";
import {SpinnerModal} from "../../../public/components/SpinnerModal";

class DealershipCodes extends React.Component {

  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {
    this.props.dispatchFetchDealerCodes();
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.fetchDealerCodes && nextProps.fetchDealerCodes.codes) {
      this.setState({...nextProps.fetchDealerCodes.codes});
    }
    if (nextProps.updateDealerCodes && nextProps.updateDealerCodes.codes) {
      this.setState({...nextProps.updateDealerCodes.codes});
    }
  };

  onSave = () => {
    const {entranceCode, parkingCode} = this.state;
    this.props.dispatchUpdateDealerCodes({entranceCode, parkingCode});
  };

  onCodeChange = (e) => {
    const {target: {name, value}} = e;
    this.setState({[name]: value});
  };

  dealerHasLockPark = () => {
    const {mainServices: {offering: {lock} = {}} = {}} = this.props;
    return lock;
  };

  render() {
    const {intl: {formatMessage}, loading, updateDealerCodes: {error = {}}, configurationHints} = this.props;
    const {entranceCode, parkingCode, lastEntranceCode, lastParkingCode} = this.state;

    const errors = error.content || {};
    const entranceRenew = lastEntranceCode && moment(lastEntranceCode).isBefore(moment().subtract(14, 'days'));
    const parkingRenew = lastParkingCode && moment(lastParkingCode).isBefore(moment().subtract(14, 'days'));

    const requiredConfig = configurationHints.includes('LOCK_PARK_CODE');

    return (
      <section className="box">
        <header className="box-heading">
          <h2 className="box-heading__title">
            {formatMessage({id: 'section.dealership-codes-configuration.title'})}
          </h2>
          <div className="box-heading__button">
            <button onClick={this.onSave} disabled={loading} type="primary" className="btn btn-sm btn-primary">
              {formatMessage({id: 'action.save'})}
            </button>
          </div>
        </header>
        <div className="box__body">
          {requiredConfig && <div className={"alert alert--error"}>{formatMessage({id: 'section.requires-configuration'}, {sectionName: formatMessage({id: 'section.dealership-codes-configuration.title'})})}</div>}

          <SpinnerModal visible={loading}/>
          <div className="row">
            <div className="col-md-6 col-xxl-6">
              <h3 className="box__subtitle">{formatMessage({id:'dealer.building'})}</h3>
              <SAInputLabel name='entranceCode' label='dealer.code' value={entranceCode} onChange={this.onCodeChange} maxLength={15}/>
              {lastEntranceCode &&
                <div>
                  <label>{formatMessage({id: 'safe.lastChange'})}:<DateFormat className="ml-1" layout="dateTimeLong" date={lastEntranceCode}/></label>
                  <br/>
                  {entranceRenew && <WarningText text={formatMessage({id: 'dealer.code.last-modified.exceeded'}, {value: 14})}/>}
                </div>
              }
            </div>

            {this.dealerHasLockPark() &&
              <div className="col-md-6 col-xxl-6">
                <h3 className="box__subtitle">{formatMessage({id:'dealer.parking'})}</h3>
                <SAInputLabel name='parkingCode' label='dealer.code' value={parkingCode} onChange={this.onCodeChange}
                              error={errors.parkingCode} maxLength={15}/>
                {lastParkingCode &&
                  <div>
                    <label>{formatMessage({id: 'safe.lastChange'})}:<DateFormat className="ml-1" layout="dateTimeLong" date={lastParkingCode}/></label>
                    <br/>
                    {parkingRenew && <WarningText text={formatMessage({id: 'dealer.code.last-modified.exceeded'}, {value: 14})}/>}
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </section>
    )
  }
}

const mapStateToProps = state => ({
  fetchDealerCodes: state.fetchDealerCodes,
  updateDealerCodes: state.updateDealerCodes,
  loading: state.fetchDealerCodes.loading || state.updateDealerCodes.loading,
  configurationHints: state.dealerConfigurationCheck && state.dealerConfigurationCheck.configurationHints || [],

});

const mapDispatchToProps = dispatch => ({
  dispatchFetchDealerCodes: () => dispatch({type: 'FETCH_DEALER_CODES.REQUEST'}),
  dispatchUpdateDealerCodes: (body) => dispatch({type: 'UPDATE_DEALER_CODES.REQUEST', body}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(DealershipCodes), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));



// WEBPACK FOOTER //
// ./src/components/safes/codes/DealershipCodes.js